function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Extension of memoizee that clears the entire cache when it's full.
 * This avoids the situation where LRU cache starts thrashing when it fills up.
 * Could look at writing our own memoize with a smarter cache to avoid overhead of
 * LRU queue, but this should be sufficient for now.
 */
import memoizee from 'memoizee';

/**
 * @param fn The function to memoize
 * @param options The options to set for memoization
 */
// eslint-disable-next-line @typescript-eslint/ban-types
export function memoizeClear(fn, options) {
  var isClearingCache = false;
  var memoizedFn = memoizee(fn, _objectSpread(_objectSpread({}, options), {}, {
    dispose: () => {
      // Need to track when we're clearing because dispose gets called for all items removed
      if (!isClearingCache) {
        isClearingCache = true;
        memoizedFn.clear();
        isClearingCache = false;
      }
    }
  }));
  return memoizedFn;
}
export default memoizeClear;
//# sourceMappingURL=memoizeClear.js.map